import { pipe } from 'fp-ts/lib/function';
import { z } from 'zod';
import { isFieldHidden } from '~/components/FieldHidden';
import { generateByComponentType } from './generateByComponentType';
import { generateCustomValidations } from './generateCustomValidations';
import { generateFieldOptional } from './generateFieldOptional';
import type { FieldsSchema } from '~/shared/domain/models';

export const generateFieldSchema = (field: FieldsSchema) => {
  if (!isFieldHidden(field)) {
    return pipe(
      field,
      generateCustomValidations,
      generateByComponentType(field),
      generateFieldOptional(field),
    );
  }
  return z.string().optional();
};
